import React from 'react';
import { autobind } from 'core-decorators';
import { FormattedMessage, injectIntl } from 'react-intl';

import http from 'src/services/httpService';
import { Form, Schema } from 'src/utils/form';
import Button from 'src/componentes/button';
import Dialog from 'src/componentes/dialog';
import LoadingContainer from 'src/componentes/loading-container';
import errorHandler from 'src/utils/error-handler';
import Checkbox from 'src/componentes/checkbox';
import ValidacaoRestricaoLista from 'src/componentes/validacao-restricao-lista/ValidacaoRestricaoLista';

const schema = Schema.object({
  restricoes: Schema.array(),
  podeExcluir: Schema.boolean(),
});

@autobind
class ValidacaoRestricao extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: !!props.url,
      checked: false,
    };

    this.form = new Form({
      component: this,
      schema: schema,
    });

    this.dialogRef = React.createRef();
    this.exclusaoEmAndamento = false;
  }

  changeValues(field, value) {
    this.setState({
      [field]: value,
    });
  }

  componentDidMount() {
    if (this.props.url) {
      const parametros = this.props.validarAlteracao
        ? { id: this.props.item.id, alteracao: true }
        : { id: this.props.item.id };
      http
        .post(this.props.url, parametros)
        .then((response) => {
          this.form.setValue(null, response.data);
          this.setState({ isLoading: false });
        })
        .catch((error) => {
          errorHandler(error);
          this.setState({ isLoading: false });
        });
    }
  }

  componentWillUnmount() {
    this.props.onUnmount?.();
  }

  handleClose() {
    if (this.dialogRef.current) {
      this.dialogRef.current.close();
    }
  }

  handleCancel() {
    if (!this.exclusaoEmAndamento) this.handleClose();
  }

  async handleSalvarClick() {
    if (!this.props.urlExclusao) {
      this.props.atualizar && this.props.atualizar(this.handleClose);

      if (this.props.urlList) {
        window.location.href = this.props.urlList;
      }

      return;
    }

    if (this.exclusaoEmAndamento) return;
    this.exclusaoEmAndamento = true;
    this.setState({ isLoading: true });

    try {
      await http.post(this.props.urlExclusao, {
        id: this.props.item.id,
      });

      this.props.afterRemove?.(this.props.item);
      this.props.onClose?.(true);
      this.handleClose();

      this.props.atualizar && this.props.atualizar(this.handleClose);

      if (this.props.urlList) {
        window.location.href = this.props.urlList;
      }
    } catch (error) {
      errorHandler(error);
    } finally {
      this.exclusaoEmAndamento = false;
      this.setState({ isLoading: false });
    }
  }

  obterTitulo() {
    if (this.props.titulo) {
      return this.props.titulo;
    }

    if (this.props.validarAlteracao) {
      return <FormattedMessage id="alterar" />;
    }

    if (this.props.termoEntidade) {
      return (
        <FormattedMessage
          id="label.excluirEntidade"
          values={{ entidade: this.props.termoEntidade }}
        />
      );
    }

    return <FormattedMessage id="excluir" />;
  }

  render() {
    const podeExcluir = this.form.getModel('podeExcluir').value;
    const restricoes = this.form.getModel('restricoes').value || [];
    const bloquearExclusao = !this.props.validarAlteracao && !podeExcluir;
    const exigeConfirmacaoExclusao =
      !!podeExcluir && !this.props.validarAlteracao;

    const actions = [
      <Button
        key="cancelar"
        onClick={this.handleCancel}
        color="secondary"
        className="validacao-restricao-modal__cancelar"
      >
        <FormattedMessage id="label.cancelar" />
      </Button>,
    ];

    if (podeExcluir) {
      actions.push(
        <Button
          disabled={
            this.state.isLoading ||
            (exigeConfirmacaoExclusao && !this.state.checked)
          }
          color="danger"
          key="confirmar"
          className="ml-2"
          onClick={this.handleSalvarClick}
        >
          {this.props.validarAlteracao ? (
            <FormattedMessage id="label.confirmar" />
          ) : (
            <FormattedMessage id="label.confirmarExclusao" />
          )}
        </Button>
      );
    }

    return (
      <Dialog
        actions={actions}
        title={this.obterTitulo()}
        width={500}
        padContent
        onRequestClose={this.handleCancel}
        mouseDownClose={false}
        ref={this.dialogRef}
        remove={this.props.remove}
        ignoreResourceTitle
        removeTitleMargin
        textCapitalizeTitle={false}
        titleCapitalizeNone
        allowMaximize={false}
        maxHeight={448}
        respeitarAltura
        className="validacao-restricao-modal"
      >
        <LoadingContainer
          isLoading={this.state.isLoading}
          className={`validacao-restricao-modal__corpo${
            this.state.isLoading
              ? ' validacao-restricao-modal__corpo--carregando'
              : ''
          }`}
        >
          <ValidacaoRestricaoLista
            restricoes={restricoes}
            instrucao={
              bloquearExclusao ? (
                <FormattedMessage id="label.paraExcluirRemovaVinculos" />
              ) : (
                this.props.instrucao
              )
            }
            paginar={this.props.paginar}
          />

          {exigeConfirmacaoExclusao && (
            <Checkbox
              className="mb-2 mt-3 validacao-restricao-modal__checkbox"
              model={{
                label: this.props.intl.formatMessage({
                  id: 'cienteAcaoIrreversivel',
                }),
                value: this.state.checked,
                requestChange: this.changeValues.bind(this, 'checked'),
              }}
            />
          )}
        </LoadingContainer>
      </Dialog>
    );
  }
}

export default injectIntl(ValidacaoRestricao);
